import React, { useMemo } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { openCaseMgmtPortalWithAuth } from '../../utils/caseMgmtPortal.utils';
import { LoadingSpinner } from '../Loading/LoadingSpinner';

const CASE_MGMT_ROUTE_PREFIX = '/case-management';

/**
 * Opens or reuses the named Case Management Portal tab for case-management routes.
 * Requires a user click so `window.open` runs under a transient user activation (popup-blocker safe).
 */
export const CaseMgmtRedirect: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const cmpPath = useMemo(() => {
    const query = searchParams.toString();
    const queryPart = query ? `?${query}` : '';
    const pathSuffix = location.pathname.replace(new RegExp(`^${CASE_MGMT_ROUTE_PREFIX}/?`), '');
    const path = `${pathSuffix ? `/${pathSuffix}` : ''}${queryPart}`;
    return path || undefined;
  }, [location.pathname, searchParams]);

  const handleOpenCaseManagement = () => {
    openCaseMgmtPortalWithAuth(cmpPath);
    navigate('/dashboard', { replace: true });
  };

  return (
    <div className="flex min-h-0 w-full flex-1 flex-col items-center justify-center gap-4 px-8 py-8">
      <LoadingSpinner
        layout="embedded"
        message="Ready to open Case Management"
        ariaLabel="Ready to open Case Management"
      />
      <button
        type="button"
        onClick={handleOpenCaseManagement}
        className="inline-flex items-center rounded-md border border-border bg-background-primary px-4 py-2 text-sm font-medium text-text-primary transition hover:bg-background-secondary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
      >
        Open Case Management
      </button>
    </div>
  );
};
